import {
  SURVEY_QUESTION_TYPES,
  SURVEY_QUESTION_TYPE_LABELS,
  type SurveyQuestionType,
} from '@citizen-walk/shared-types';

/**
 * 質問タイプを選んで質問を末尾に追加するプルダウン (地区アンケート / マスタのテンプレ共用)。
 * 質問一覧の上と下の両方に置く (質問が多いと最下部から上まで戻らないと追加できなかったため)。
 */
export interface AddSurveyQuestionSelectProps {
  onAdd: (type: SurveyQuestionType) => void;
  disabled?: boolean;
  /** 上下に 2 つ置くため、読み上げ名で区別する。 */
  ariaLabel?: string;
}

export function AddSurveyQuestionSelect({
  onAdd,
  disabled,
  ariaLabel = '質問を追加',
}: AddSurveyQuestionSelectProps) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-xs text-slate-500">追加:</span>
      <select
        onChange={(e) => {
          if (e.target.value) {
            onAdd(e.target.value as SurveyQuestionType);
            e.target.value = '';
          }
        }}
        disabled={disabled}
        defaultValue=""
        aria-label={ariaLabel}
        className="min-h-touch px-2 border border-slate-300 rounded text-xs bg-white"
      >
        <option value="">— 質問タイプを選択 —</option>
        {SURVEY_QUESTION_TYPES.map((t) => (
          <option key={t} value={t}>
            {SURVEY_QUESTION_TYPE_LABELS[t]}
          </option>
        ))}
      </select>
    </div>
  );
}
